<div class="loginPage" *ngrxLet="authFacade.getUserId$ as getUserId">
  <form [formGroup]="otpForm" (ngSubmit)="onSubmit(getUserId)" novalidate>
    <div class="content">
      <div class="container">
        <span class="form-title">Verify Your Login</span>

        <p class="verification-text">
          Please enter the verification code sent to<br />
          <span class="email-mask">{{ userEmail }}</span>
        </p>

        <div class="otp-container">
          <input
            #otpInput
            *ngFor="let control of otpControls; let i = index"
            type="number"
            class="otp-input"
            maxlength="1"
            [formControl]="control"
            (keyup)="onKeyUp($event, i)"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            (keydown)="onKeyDown($event, i)"
            (paste)="handlePaste($event, i)"
          />
        </div>
        <ng-container *ngrxLet="authFacade.otpVerifyError$ as otpVerifyError">
          <div class="input-error invalidError" [innerHTML]="otpVerifyError"></div>
        </ng-container>
        <div *ngIf="isExpired" class="input-error invalidError">
          OTP has expired. Please request a new one.
        </div>
        <div class="timer" *ngIf="!isExpired">
          Code expires in: <span>{{ timerDisplay }}</span>
        </div>
        <div class="form-actions box">
          <button
            type="submit"
            class="modelBtn purpleBtnHoverEffect"
            [disabled]="!otpForm.valid || isExpired"
          >
            Verify
          </button>
        </div>

        <div class="resend-code">
          <span
            ><a (click)="resendOTP(getUserId)" class="linkText">Resend verification code</a></span
          >
          &nbsp;
          <span style="color: black">|</span>
          &nbsp;
          <span><a class="linkText" (click)="backToLogin()">Back to login</a></span>
        </div>
      </div>
    </div>
  </form>
</div>
